import { ROLES } from "utils/helpers/enums/roles.enum";
import {
  GENDERS,
  RESOURCE_TAGS,
  USER_STATUSES,
} from "utils/helpers/enums/shared.enum";

export class ResourceLibFiltersDTO {
  page: number = 0;
  limit: number = 10;
  count: number = 1;
  totalPages: number = 1;
  size: number = 10;
  title: string = "";
  role: ROLES = ROLES.ATTENDEE;
  tag?: RESOURCE_TAGS | "";
}
